<template>
  <a-col :span="24">
    <a-form :form="form" >  
	      <a-row>
          <a-col v-if="devType === 'mobile' ">
            <a-menu
              v-model="current"
              mode="horizontal"
              @click="handleMenu"
            >
              <a-menu-item key="info" style="padding: 0px 8px 0px 8px;">
                <a style="color: #1890ff;">推广设置</a>
              </a-menu-item>
              <a-menu-item key="preview" style="padding: 0px 8px 0px 8px;">
                <a style="color: #1890ff;">效果预览</a>
              </a-menu-item>
            </a-menu>
          </a-col>

          <a-col v-if="menu_tag === 'info' || devType === 'pc'" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">

      	      <a-form-item>
                  <a-col :xs="7" :sm="7" :md="6" :lg="6" :xl="6" style="text-align: right;">
                    <span style="color: red;">* <span style="color: black; margin-right: 5px;">推广名称:</span></span>
                  </a-col>
                  <a-col :xs="16" :sm="16" :md="18" :lg="18" :xl="18">
                    <a-input placeholder="示例：焕颜芦笋粉" v-model='title'>
                      <a-icon slot="prefix" type="project" />
                    </a-input>
                  </a-col>
              </a-form-item>

              <a-form-item>
                  <a-col :xs="7" :sm="7" :md="6" :lg="6" :xl="6" style="text-align: right;">
                    <span style="color: black; margin-right: 5px;">标语:</span>
                  </a-col>
                  <a-col :xs="16" :sm="16" :md="18" :lg="18" :xl="18">
                    <a-input placeholder="示例：萃取芦笋精华，得享健康本源" 
                      v-model='slogan'>
                      <a-icon slot="prefix" type="notification" />
                    </a-input>
                  </a-col>
              </a-form-item>

              <a-form-item >
                  <a-col :xs="7" :sm="7" :md="6" :lg="6" :xl="6" style="  text-align: right; ">
                    <span style="color: red;">* <span style="color: black;margin-right: 5px;">落 地 页:</span></span>
                  </a-col>
                  <a-col :xs="16" :sm="16" :md="18" :lg="18" :xl="18">
                    <a-input placeholder="落地页网址"  v-model='landing_url'>
                      <a-icon slot="prefix" type="link" />
                    </a-input>
                  </a-col>
              </a-form-item>

              <a-form-item> 
                    <a-col :xs="7" :sm="7" :md="6" :lg="6" :xl="6" style="text-align: right;">
                        <span style="color: red;">* <span style="color: black; margin-right: 5px;">联系电话:</span></span>
                    </a-col>
                   <a-col :xs="16" :sm="16" :md="18" :lg="18" :xl="18">            
                          <a-input v-model='contact_phone'>
                            <a-icon slot="prefix" type="phone" />
                          </a-input>
                    </a-col>
              </a-form-item>

              <a-form-item>
                    <a-col :xs="7" :sm="7" :md="6" :lg="6" :xl="6" style="  text-align: right; ">
                    <span style="color: black;margin-right: 5px;">联系人姓名:</span>
                    </a-col>
                    <a-col :xs="16" :sm="16" :md="18" :lg="18" :xl="18">  
                          <a-input v-model='contact_name'>
                            <a-icon slot="prefix" type="user" />
                          </a-input>
                    </a-col>
              </a-form-item>

              <a-form-item>
                    <a-col :xs="7" :sm="7" :md="6" :lg="6" :xl="6" style="  text-align: right; ">
                    <span style="color: black;margin-right: 5px;">微信号:</span>
                    </a-col>
                    <a-col :xs="16" :sm="16" :md="18" :lg="18" :xl="18">  
                          <a-input v-model='wechat_id'>
                            <a-icon slot="prefix" type="wechat" />
                          </a-input>
                    </a-col>
              </a-form-item>  

              <a-form-item  :wrapper-col="{ span: 24}" required>
                  <a-col :xs="7" :sm="7" :md="6" :lg="6" :xl="6" style="  text-align: right; ">
                    <span style="color: black; margin-right: 5px;">说明:</span>
                  </a-col>
                  <a-col :xs="16" :sm="16" :md="18" :lg="18" :xl="18">
                    <a-textarea  v-model='desc' rows="11" placeholder="输入关于待推广产品或服务的说明。说明越详尽，爱助手找到的推广文章会越精确。">
                      <a-icon slot="prefix" type="snippets" />
                    </a-textarea>
                  </a-col>
              </a-form-item> 

              <a-row >
                <a-col :xs="7" :sm="7" :md="6" :lg="6" :xl="6">
                </a-col>
                <a-col :xs="17" :sm="17" :md="18" :lg="18" :xl="18">
                  <a-button type="primary"  @click= "handleUpload"> {{button_name}} </a-button>
                  <a-button type="primary" @click="handleClose" style="background-color:gray;color:white; margin-left: 10px;">关闭</a-button>
                </a-col>
              </a-row>
          </a-col>

          <a-col v-if="menu_tag === 'preview' || devType === 'pc'" 
              :xs="24" :sm="24" :md="12" :lg="12" :xl="12" 
              class="mobile-view"
              style="height: 600px;"
              >
              <a-row style="height: 15%;">
              </a-row>
              <a-row
                  style="height: 55%;"
                  >
                  <a-upload name="Ad_image" 
                      listType="picture-card" 
                      class="avatar-uploader" 
                      :showUploadList="false" 
                      action="" 
                      :beforeUpload="beforeUpload_Ad_image" 
                      @change="upload_Ad_image"  
                      >
                      <img class="ads-image" v-if="ad_image" :src="ad_image" alt="avatar"/>
                      <div v-else>
                        <a-icon :type="loading_ad ? 'loading' : 'plus'" />
                        <div class="ant-upload-text">点击上传图片</div>
                      </div>
                  </a-upload>
              </a-row>
              <a-row style="height: 15%;">
              </a-row>
              <a-row style="margin-left: 15%; margin-right: 15%; height: 10%;">
                <a-col :span="6" style="text-align: center;">
                    <a-upload
                        name="avatar"
                        :showUploadList="false"
                        action=""
                        :beforeUpload="beforeUpload_Logo_image"
                        @change="upload_Logo_image"
                        >
                        <a-avatar v-if="logo_image" :size="50" :src="logo_image" alt="avatar" style="margin-top: 5%;" />
                        <a-avatar v-else :size="50" icon="user" :type="loading_logo ? 'loading' : 'plus'" style="margin-top: 5%;"
                        />
                    </a-upload>
                </a-col>
                <a-col :span="10" class="clickable-text" style="padding-top: 4px;">
                    <a-col v-if="title != '' || slogan != '' " style="margin-top: 5%;">
                        <div @click="sloganModel" 
                          style="width: 90px; height: 24px;overflow: hidden;font-size: 16px; font-weight: 600;">
                          {{title}}
                        </div>
                        <div @click="sloganModel" style="width: 90px; height: 16px;overflow: hidden;font-size: 12px;">
                          {{slogan}}
                        </div>
                    </a-col>
                    <a-col v-else style="margin-top: 15%;">
                        <span @click="sloganModel">+点击编辑</span>
                    </a-col>
                </a-col>
                <a-col :span="8">
                    <a-col :span="12" style="text-align: center;">
                          <img 
                            src="../../assets/img/phone-icon.png" 
                            @click="phoneModel" 
                            alt="avatar" 
                            class="clickable-icon"
                            style="height: 20px; margin-top: 40%;"/>
                    </a-col>
                    <a-col :span="12"  style="text-align: center;">
                        <img 
                            src="../../assets/img/wechat-icon.png" 
                            @click="wechatModel" 
                            alt="avatar" 
                            class="clickable-icon"
                            style="height: 20px; margin-top: 40%;"/>
                    </a-col>
                </a-col>
              </a-row>
              <a-row style="height: 5%;">
              </a-row>
          </a-col>
        </a-row >

        <a-row >
          <a-modal v-model="slogan_model" :footer="null" width="340px" 
            style="top: 30%;">
                  <a-row style="margin-top: 30px; text-align: right;">
                      <a-input v-model='temp_title' placeholder="活动名"/>
                      <a-input v-model='temp_slogan' placeholder="活动标语" style="margin-top: 10px;"/>
                  </a-row>
                  <a-row>
                    <a-col style="margin-top: 10px; text-align: left;">
                      <a-button type="primary" @click="sloganOK">完成</a-button>
                    </a-col>
                  </a-row>
          </a-modal>
          <a-modal v-model="phone_model" :footer="null" width="340px" 
            style="top: 30%;">
                  <a-row style="margin-top: 30px; text-align: right;">
                    <a-col>
                      <a-input v-model='temp_contact_phone' placeholder="联系电话"/>
                      <a-input v-model='temp_contact_name' placeholder="联系人姓名" style="margin-top: 10px;"/>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col style="margin-top: 10px; text-align: left;">
                      <a-button type="primary" @click="phoneOK">完成</a-button>
                    </a-col>
                  </a-row>
          </a-modal>
          <a-modal v-model="wechat_model" :footer="null" width="340px" 
            style="top: 20%;">
                  <a-row style="margin-top: 25px; text-align: center;">
                    <a-col style=" height: 210px;">
                            <a-upload name="QR_code" 
                                listType="picture-card" 
                                class="avatar-uploader" 
                                :showUploadList="false"       
                                action=""
                                :beforeUpload="beforeUpload_QR_code" 
                                @change="upload_QR_code"
                                >
                                <img class="show_qr" v-if="temp_qr_image" :src="temp_qr_image" alt="avatar" />
                                <div v-else>
                                  <a-icon :type="loading_qr ? 'loading' : 'plus'" />
                                  <div class="ant-upload-text">点击上传图片</div>
                                </div>
                            </a-upload>
                    </a-col>
                  </a-row>
                  <a-row style="margin-top: 25px; text-align: right;">
                    <a-col>
                      <a-input v-model='temp_wechat_id' placeholder="微信"/>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col  style="margin-top: 10px; text-align: left;">
                      <a-button type="primary" @click="wechatOK">完成</a-button>
                    </a-col>
                  </a-row>
          </a-modal>
        </a-row>
      </a-form>
  </a-col>
</template>

<script>
import reqwest from 'reqwest'
import {BACKEND_API_PREFIX} from '@/util/config'

function getBase64 (img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}
export default {
  components:{},

  props: {
    item: {
      type: Object,
      default: function() {
        return {
          title: "",
          landing_url: "",
          slogan: "",
          desc: "",
          contact_name: "",
          contact_phone: "",
          wechat_id: "",
          img: {},
          temp_title: "",
          temp_slogan: "",
          temp_contact_name: "",
          temp_contact_phone: "",
          temp_wechat_id: "",
          temp_qr_file: "",
          temp_qr_image: "",
        }
      }
    }
  },
  data () {
    return {
      current: ['info'],
      menu_tag: "info",
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      loading_ad: false,
      loading_qr: false,
      loading_logo: false,
      title: this.item.title,
      landing_url: this.item.landing_url,
      slogan: this.item.slogan,
      desc: this.item.desc,
      contact_name: this.item.contact_name,
      contact_phone: this.item.contact_phone,
      wechat_id: this.item.wechat_id,
      BACKEND_API_PREFIX: BACKEND_API_PREFIX,
      ad_image: BACKEND_API_PREFIX + this.item.img.ads,
      logo_image: BACKEND_API_PREFIX + this.item.img.icon,
      qr_image: BACKEND_API_PREFIX + this.item.img.qrcode,
      ad_file: '',
      qr_file: '',
      logo_file: '',
      visible: false,
      id: this.item.id,
      user: {},
      devType: "pc",
      slogan_model: false,
      phone_model: false,
      wechat_model: false,
      temp_title: this.item.temp_title,
      temp_slogan: this.item.temp_slogan,
      temp_contact_phone: this.item.temp_contact_phone,
      temp_contact_name: this.item.temp_contact_name,
      temp_wechat_id: this.item.temp_wechat_id,
      temp_qr_file: this.item.temp_qr_file,
      temp_qr_image: this.item.temp_qr_image,
    }
  },
  watch: {
    item: function(newvalue, oldvalue) {
      this.title = newvalue.title;
      this.landing_url = newvalue.landing_url;
      this.slogan = newvalue.slogan;
      this.desc = newvalue.desc;
      this.contact_name = newvalue.contact_name;
      this.contact_phone = newvalue.contact_phone;
      this.wechat_id = newvalue.wechat_id;
      this.ad_image = this.BACKEND_API_PREFIX + newvalue.img.ads;
      this.logo_image = this.BACKEND_API_PREFIX + newvalue.img.icon;
      this.qr_image = this.BACKEND_API_PREFIX + newvalue.img.qrcode;
    }

  },

  methods: {
    handleMenu (value) {
      this.menu_tag= value.key;
    },
    sloganModel() {
      this.temp_title= this.title;
      this.temp_slogan = this.slogan;
      this.slogan_model = true
    },
    phoneModel() {
      this.temp_contact_phone = this.contact_phone;
      this.temp_contact_name = this.contact_name;
      this.phone_model = true
    },
    wechatModel() {
      this.temp_wechat_id = this.wechat_id;
      this.temp_qr_file = this.qr_file;
      this.temp_qr_image = this.qr_image;
      this.wechat_model = true
    },
    showModal() {
      this.visible = true
    },
    handleClose() {
      this.$emit('success', 'close');
    },
    handleCancel(e) {
      this.visible = false
    },
    sloganOK () {
      this.title = this.temp_title;
      this.slogan = this.temp_slogan;
      this.slogan_model = false
    },
    phoneOK () {
      this.contact_phone = this.temp_contact_phone;
      this.contact_name = this.temp_contact_name;
      this.phone_model = false
    },
    wechatOK () {
      this.wechat_id = this.temp_wechat_id;
      this.qr_file = this.temp_qr_file;
      this.qr_image = this.temp_qr_image;
      this.wechat_model = false
    },
    handleUpload (e){
      let title = this.title;
      let landing_url = this.landing_url;
      let slogan = this.slogan;
      let desc = this.desc;
      let contact_name = this.contact_name;
      let contact_phone = this.contact_phone;
      let wechat_id = this.wechat_id;
      let ad_file=this.ad_file;
      let qr_file=this.qr_file;
      let logo_file=this.logo_file;
      let id = this.id;

      if (!title) {
        this.$message.info("请填写推广的标题");
        return;
      }
      if (!landing_url) {
        this.$message.info("请填写落地页网址");
        return;
      }
      if (!contact_phone) {
        this.$message.info("请填写联系人电话");
        return;
      }
      if(!id){
        if (!ad_file) {
          this.$message.info("请点击推广预览图中部的上传图片区域，设置推广的主图片");
          return;
        }
        if (!qr_file) {
          this.$message.error("请点击推广预览图右下方的微信图标，上传联系人的微信二维码");
          return;
        }
        if (!logo_file) {
          this.$message.error("请点击推广预览图左下方的用户图标区，设置联系人的个性化图标");
          return;
        }
      }

      const formData = new FormData();
      if (logo_file)
        formData.append('icon', logo_file);
      if (qr_file)
        formData.append('qrcode', qr_file);
      if (ad_file)
        formData.append('ads', ad_file);
      if (title) 
        formData.append('title', title);
      if (landing_url)
        formData.append('landing_url', landing_url);
      if (slogan)
        formData.append('slogan', slogan);
      if (desc)
        formData.append('desc', desc);
      if (contact_name)
        formData.append('contact_name', contact_name);
      if (contact_phone)
        formData.append('contact_phone', contact_phone);
      if (wechat_id)
        formData.append('wechat_id', wechat_id);
      if(!id){
        formData.append('task', "ADD_TEMPLATE")
      }
      else{
        formData.append('task', "UPDATE_TEMPLATE")
        formData.append('id', this.item.id)
      }
      formData.append('agent_key', this.$store.getters.getAgentkey())
      formData.append('access_token', this.$store.getters.getToken())
        
      let that = this;
      reqwest({
        url: BACKEND_API_PREFIX + 'ads',
        method: 'post',
        processData: false,
        data: formData,
        success: (resp) => {
          that.fileList = []
          that.uploading = false
            
          let rsp = JSON.parse(resp);
          if (rsp.ret == 200){
            that.item["id"] = rsp.data.id;
            that.id = rsp.data.id;
            that.$message.success('上传成功！');
            that.$emit('success', 'refresh');
          } else{
            that.$message.error('上传失败！');
          }
        }, error: () => {
          that.uploading = false
          that.$message.error('上传失败！');
        }
      })
    },

    beforeUpload_Ad_image (file) {
      const isLt2M = file.size / 1024 / 1024 < 0.15
      this.ad_file = file
      if (!isLt2M) {
        this.$message.error('图片文件大小不能超过 150kb!')
      }
      return isLt2M 
    },
    beforeUpload_QR_code (file) {
      const isLt2M = file.size / 1024 / 1024 < 2.0
      this.temp_qr_file = file
      if (!isLt2M) {
         this.$message.error('图片文件大小不能超过 2MB!')
      }
      return isLt2M
    },
    beforeUpload_Logo_image (file) {
      const isLt2M = file.size / 1024 / 1024 < 0.512
      this.logo_file = file;
      if (!isLt2M) {
        this.$message.error('图片文件大小应小于512KB!')
      }
      return isLt2M
    },
    upload_Ad_image (info) {  
      if (info.file.status === 'uploading') {
        this.loading_ad = true
        return
      }
      getBase64(info.file.originFileObj, (imageUrl) => {
        this.ad_image = imageUrl
        this.loading_ad = false
      })
    },
    upload_QR_code (info) { 
      if (info.file.status === 'uploading') {
        this.loading_qr = true
        return
      }
      getBase64(info.file.originFileObj, (imageUrl) => {
        this.temp_qr_image = imageUrl
        this.loading_qr = false
      })
    },
    upload_Logo_image (info) {
      if (info.file.status === 'uploading') {
        this.loading_logo = true
        return
      }
      getBase64(info.file.originFileObj, (imageUrl) => {
          this.logo_image = imageUrl
          this.loading_logo = false
      })
    },
  },
  created() {
    if (this.item.id) {
      this.button_name = "保存"
    } else {
      this.button_name = "保存"
    }
    let deviceWidth = document.body.clientWidth
    if (deviceWidth <= 500) {
      this.devType = 'mobile';
    }
    let postdata = {
      'task':'GET_USER_INFO',
      'id':this.$store.getters.getId()
    };
    let that = this;
    that.post('user', postdata)
    .then(function(data){
      if(data.ret ==200){
        that.user=data.data;
      }
    }).catch(function(e){
        console.log(e);
      });
  }
}
</script>

<style scoped>
  div /deep/.ant-menu-horizontal {
    border: 0;
    border-bottom: 1px solid #e8e8e8;
    -webkit-box-shadow: none;
    box-shadow: none;
    line-height: 35px;
    margin-bottom: 10px;
    white-space: nowrap;
  }
  .avatar-uploader > .ant-upload {
    width: 128px;
    height: 128px;
  }
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }
  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }

  .ads-image{
    width: 100%;
    height: 300px;
    border-radius:10px;
    animation: zoominout-ads 3s linear 30s infinite alternate;
  }

  .show_qr{
    width: 150px;
    height: 150px;
  }
  .img_preview{
    width: 200px;
    height: 300px;
  }
  .preview-item {
    padding: 16px; 
    text-align: center;
  }
  .mobile-view {
    background-image: url('../../assets/img/mobile-panel.png');
    background-size: 320px 600px;
    background-position: 50% 50%;
    background-repeat: no-repeat;
  }

  div /deep/.ant-upload.ant-upload-select-picture-card {
    border: 0px dashed #1890ff;
    border-radius:10px;
    margin: auto;
    width: 65%;
    height: 100%;
  }
  div /deep/ .ant-form-item {  
    margin-bottom: 12px; 
  }

  div.attention { 
    animation: attention 2s linear 10s infinite alternate;
  }

  div.clickable-text{ 
    animation: text-attention 3s linear 30s infinite alternate;
  }

  div /deep/ .ant-avatar > img { 
    animation: zoominout-50 3s linear 30s infinite alternate;
  }

  img.clickable-icon { 
    animation: zoominout 3s linear 30s infinite alternate;
  }

  @keyframes zoominout{
    0%   {height: 20px; width: 20px; }
    15%  {height: 25px; width: 25px; }
    30%  {height: 20px; width: 20px; }
    100% {height: 20px; width: 20px; }
  }

  @keyframes zoominout-50{
    0%   {height: 50px; width: 50px; }
    15%  {height: 40px; width: 40px; }
    30%  {height: 50px; width: 50px; }
    100% {height: 50px; width: 50px; }
  }

  @keyframes zoominout-ads{
    0%   {height: 300px; width: 100%; }
    15%  {height: 270px; width: 90%; }
    30%  {height: 300px; width: 100%; }
    100% {height: 300px; width: 100%; }
  }

  @keyframes text-attention{
    0% {color: black;}
    15% {color: red;}
    30% {color: black;}
    100% {color: black;}
  }

  @keyframes attention{
    0% {border: 1px solid white;}
    15% {border: 1px solid red;}
    30% {border: 1px dashed #1890ff;}
    100% {border: 1px dashed #1890ff;}
  }
</style>
